import { ref } from 'vue'

const STORAGE_KEY = 'omnidars:sidebar-collapsed'

const isSidebarCollapsed = ref(
  typeof window !== 'undefined' && localStorage.getItem(STORAGE_KEY) === '1'
)

function toggleSidebarCollapsed() {
  isSidebarCollapsed.value = !isSidebarCollapsed.value
  if (typeof window !== 'undefined') {
    localStorage.setItem(STORAGE_KEY, isSidebarCollapsed.value ? '1' : '0')
  }
}

export function useSidebarCollapse() {
  return { isSidebarCollapsed, toggleSidebarCollapsed }
}
